export const API_BASE_URL = import.meta.env.VITE_API_URL ?? ""; // @runtime-env-ok — Vite build-time inlined, no CF Workers runtime secret
